import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';
import type { FormsFilters } from '../types';

export function useForms(filters: FormsFilters, page: number, pageSize: number) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: FORM_KEYS.list(orgId ?? '', filters, page, pageSize),
    queryFn: ({ signal }) => formsService.getList(filters, page, pageSize, signal),
    staleTime: 120_000,
    enabled: !!orgId,
    placeholderData: keepPreviousData,
  });

  return {
    forms: data?.data.items ?? [],
    pageInfo: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
